import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubprocessorsEnComponent } from './subprocessors-en.component';
import { SubprocessorsSkComponent } from './subprocessors-sk.component';
import { SubprocessorsCzComponent } from './subprocessors-cz.component';

@Component({
  selector: 'app-subprocessors',
  standalone: true,
  imports: [CommonModule, SubprocessorsEnComponent, SubprocessorsSkComponent, SubprocessorsCzComponent],
  templateUrl: './subprocessors.component.html',
  styleUrls: ['./subprocessors.component.scss'],
})
export class SubprocessorsComponent {
  @Input() currentLang = 'en';

  // Shared configuration for all language versions
  lastUpdated = '01.09.2025';
  version = '1.0';
  supportEmail = 'legal@sameta.sk';
}
